// @flow
import Header from "./Header";
import BackButton from "../GUI_COMMON/COMPONENTS/BackButton";
import Popup from "../GUI_COMMON/COMPONENTS/Popup";
import ErrorPopup from "../GUI_COMMON/COMPONENTS/ErrorPopup";
import React, {useContext, useEffect, useState} from "react";
import RetrievalOrderForm from "./RetrievalOrderForm";
import ArchiverClientApi from "../API/archiverClientApi";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import {Redirect, useLocation, useParams} from "react-router-dom";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import {useCookies} from "react-cookie";
import LoadingSpinner from "../GUI_COMMON/COMPONENTS/LoadingSpinner";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";
import {Toaster} from "react-hot-toast";
import LICache from "../SUPPORT/LICache";
import {useHistory} from "react-router";

const AddUpdateROPage = () => {
    
    const DEFAULT_DUE_DATE=14;  // default due date if dueBackByDays is left blank
    
    const initialRetrievalsInfo = {
        saved: true,
        orderId: "",
        createdOn: new Date(),
        createdByName: "",
        createdById: -1,
        
        requestedByName: "",
        requestedById: -1,

        destLocation: -1,
        destDepartment: -1,
        destContact: -1,

        dueBackDate: new Date(),
        permanentlyRemove: false,

        notes: "",
        samples: []
    };
    
    const [globalState,] = useContext(StoreContext);
    const [infoGoodnessList, setInfoGoodnessList] = useState({});
    const [retrievalInfo, setRetrievalInfo] = useState(initialRetrievalsInfo);
    const [formIsValid, setFormIsValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [redirectToCaseInventory, setRedirectToCaseInventory] = useState(false);
    const [redirectToPicksheet, setRedirectToPicksheet] = useState(false);
    const [redirectToReplace, setRedirectToReplace] = useState();
    const [redirectToPush, setRedirectToPush] = useState();
    const [redirectToEditorWithSample, setRedirectToEditorWithSample] = useState();
    const [selectedCase, setSelectedCase] = useState();
    const [orderStatus, setOrderStatus] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const [checkForCompleted, setCheckForCompleted] = useState(false);
    const [savedFlag, setSavedFlag]=useState(false);     
    const [isInitializing, setIsInitializing] = useState(true);
    const [newlyAddedSampleIds, setNewlyAddedSampleIds] = useState(new Set());
    
    let {orderId} = useParams();
    orderId = Number(orderId??-1);
    
    const location = useLocation();
    const [cookies] = useCookies();
    const history = useHistory();
    const [comingFromCaseInventory] = useState(location.state?.roInProgress);
    
    useEffect( () => {
        if (comingFromCaseInventory === true) {
            console.debug("addUpdateRO: [1] coming from case inventory...copying info over");
            (async () => { 
                await readRetrievalInfoFromStorage();
                // keep Destination Location and Date Due Back blank when starting
                // a retrieval from case inventory; the user must re-enter them.
                if(location && location.pathname.indexOf("/new") > -1) { // new order - level needs to match.
                    setRetrievalInfo(prev => ({
                        ...prev, destLocation: -1, destDepartment: -1, destContact: -1, dueBackDate: null
                    }));
                }
                setIsInitializing(false);
            })();  // IIFE
            return;
        }
        if (orderId) {
            if (Number(orderId) === -1) { // new order - level needs to match.
                if (!LIUtils.UserHasLevel(cookies, "RETRIEVER")) {
                    Popup.show("", "<p>You are not a RETRIEVER type user.</p>" +
                        "Talk to your Archiver Administrator if you wish to change this.", () => {
                        setRedirectToPush("/dashboard");
                    });
                }
            }
            LICache.getRetrievalOrderId().then(storedROId => {
                if (storedROId !== -1 && storedROId === orderId) {
                    console.debug("addUpdateRO: [0] order matches stored...copying info over");
                    (async () => { 
                        await readRetrievalInfoFromStorage();
                        setIsInitializing(false);
                    })(); // IIFE
                } else if (orderId === "" || orderId === -1) {
                    (async () => { 
                        await handleClearForm();
                        setIsInitializing(false);
                    })();  // IIFE
                } else {
                    setIsLoading(true);
                    setIsInitializing(true);
                    ArchiverClientApi.getRetrievalOrderGivenId(orderId)
                    .then((response) => {
                        (async () => { 
                            await setupFormFieldData(response.order, response.samples);
                            updateSavedFlagTo(true);
                            setIsLoading(false); // not dirty currently
                            setIsInitializing(false);
                            setCheckForCompleted(true);
                        })();  // IIFE
                    })
                    .catch(responseError => {
                        ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError, () => {
                            setRedirectToPush("/retrievals");
                        });
                        setIsLoading(false);
                        setIsInitializing(false);
                        setCheckForCompleted(true);
                    })
                }
            });
        }
    },[cookies,orderId]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect( () => {
        checkForValid();
    },[retrievalInfo]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect( () => {
        if(retrievalInfo && checkForCompleted) {
            console.debug("checking for RO is completed...");
            if (retrievalInfo.samples.length > 0 && !shouldFormBeReadOnly()) {
                checkForOnlyPickedSamplesAndShowPopup(retrievalInfo.samples);
            }
            setCheckForCompleted(false); // reset
        }
    },[checkForCompleted]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect( () => {
        
        const curInfo = {...retrievalInfo};
        
        // always refresh this to be current
        curInfo.createdByName = globalState.clientInfo.fullName;
        curInfo.createdById = globalState.clientInfo.userId;

        setRetrievalInfo(curInfo);
        
    },[globalState.clientInfo]); // eslint-disable-line react-hooks/exhaustive-deps

    function shouldFormBeReadOnly() {
        if(!LIUtils.UserHasLevel(cookies,"RETRIEVER")) { // can't edit - ever
            return true;
        }
        return orderStatus.isPickedCompleted || orderStatus.isSent;
    }
    
    function showClearButtonIfRequired() {
        if(orderId!==-1) {
            return null;
        }
        return(
            <button className="li-button li-bg-success li-fg-white align-self-center mr-4" onClick={handleClearForm}>
                Clear
            </button>
        );
    }

    /**
     * reorder the information coming from the server into something that
     * our form understands, so we can reuse the form to display the details.
     *
     * @param order
     * @param samples
     */
    async function setupFormFieldData(order, samples) {

        const formFormattedInfo = initialRetrievalsInfo;
        formFormattedInfo.orderId = orderId ? Number(orderId) : null;
        formFormattedInfo.createdOn = LIUtils.dateFromJsonUtcDateStr(order.dateStarted);
        formFormattedInfo.createdById = order.creator.id;
        formFormattedInfo.createdByName = order.creator.fullName;
        formFormattedInfo.requestedByName = order.requester.fullName;
        formFormattedInfo.requestedById = order.requester.id;
        formFormattedInfo.destLocation = order.destinationLocation?.id;
        formFormattedInfo.destDepartment = order.destinationDepartment?.id;
        formFormattedInfo.destContact = order.destinationContact?.id;
        formFormattedInfo.dueBackDate = LIUtils.dateFromJsonUtcDateStr(order.dateDueBack);
        formFormattedInfo.permanentlyRemove = order.permanentlyRemove;
        formFormattedInfo.notes = order.notes;
        formFormattedInfo.samples = samples;
        formFormattedInfo.saved = true; // not updated
        
        // order is important here!
        setOrderStatus({
            isPickedCompleted: order.isPickCompleted,
            isSent: order.isSent
        })
        setRetrievalInfo(formFormattedInfo);
        await LICache.setRetrievalInfo(retrievalInfo);
    }

    async function readRetrievalInfoFromStorage() {
        console.debug("reading RetrievalInfoFromStorage");
        let curInfo = await LICache.getRetrievalInfo();
        
        // convert the date from a string back to a date -- ### hack
        curInfo.dueBackDate = curInfo.dueBackDate?new Date(curInfo.dueBackDate):new Date();
        
        // always refresh this
        curInfo.createdByName = globalState.clientInfo.fullName;
        curInfo.createdById = globalState.clientInfo.userId;
        curInfo.createdOn = curInfo.createdOn?new Date(curInfo.createdOn):new Date();
        setRetrievalInfo(curInfo);
        
        updateSavedFlagTo(curInfo.saved);
    }
    
    function updateSavedFlagTo(updatedFlag) {
        console.debug(`updating saved flag to ${updatedFlag}`);
        setSavedFlag(updatedFlag);
    }
    
    async function updateRetrievalValue(name,value) {
        const curInfo = {...retrievalInfo};
        curInfo[name]=value;
        
        // these 2 need to stay in sync
        curInfo["saved"]=false;
        updateSavedFlagTo(false);

        setRetrievalInfo(curInfo);
        await LICache.setRetrievalInfo(curInfo);        // update the backer
    }
    
    async function markFormIsDirty(isDirty:boolean) {
        const curInfo = {...retrievalInfo};
        
        // keep these 2 in sync
        curInfo["saved"]=!isDirty;
        updateSavedFlagTo(!isDirty);

        setRetrievalInfo(curInfo);
        await LICache.setRetrievalInfo(curInfo);        // update the backer
    }

    function handleAddSamples(e) {
        const caseItem = e.target.item;
        if (!caseItem || !caseItem.id || !caseItem.number) {
            ErrorPopup.showError("ERROR", "unknown case");
            return;
        }
        setSelectedCase(caseItem);
        setRedirectToCaseInventory(true);
    }

    async function handleAddSamplesViaBarcode(e) {
        const sampleItem = e.target.item;
        if (!sampleItem || !sampleItem.id || !sampleItem.barcode) {
            ErrorPopup.showError("ERROR", "unknown sample");
            return;
        }
        await LICache.addSamplesToRetrievalList([sampleItem]);
        setNewlyAddedSampleIds(new Set([sampleItem.id]));
        await readRetrievalInfoFromStorage();

        // Clear the newly added sample IDs after animation duration (1.5 seconds for flash animation)
        setTimeout(() => {
            setNewlyAddedSampleIds(new Set());
        }, 1600);

        // toast.success(`Added ${sampleItem.barcode}`, {
        //     duration: 3000,
        //     position: 'bottom-right',
        //     style: {
        //         border: '1px solid #713200',
        //         padding: '16px',
        //         fontSize: '16pt',
        //         color: 'white',
        //         background: 'green'
        //     },
        //     iconTheme: {
        //         primary: 'white',
        //         secondary: 'black',
        //     },
        // });

    }
    
    async function handleDueDateChanged(value) {
        await updateRetrievalValue("dueBackDate",value);
    }
    
    async function handleClearForm() {
        console.debug("clearing form...");

        initialRetrievalsInfo["createdByName"]=globalState.clientInfo.fullName;
        initialRetrievalsInfo["createdById"]=globalState.clientInfo.userId;
        await LICache.clearRetrievalInfo(initialRetrievalsInfo);
        
        // not saved and clean
        setRetrievalInfo({...initialRetrievalsInfo}); // copy so it changes
        updateSavedFlagTo(true);
    }
    
    async function handleInfoChanged(event) {
        console.debug(`handleInfoChanged for ${event.target?.name}`);
        let updateInfo = {...retrievalInfo};
        const thing = event.target.name;
        switch (thing) {
            case "permanentlyRemove":
                // convert
                updateInfo[thing] = event.target.checked;
                break;
            case "ro-destLocation":
                const locId = Number(event.target.value)
                updateInfo["destLocation"] = locId;
                updateInfo["destDepartment"] = -1;
                updateInfo["destContact"] = -1;
                const preferredDueDate = getReturnDateBasedOnLocation(locId);
                updateInfo["dueBackDate"] = preferredDueDate;
                break;
            case "ro-destDepartment":
                updateInfo["destDepartment"] = Number(event.target.value);
                updateInfo["destContact"]=-1;
                break;
            case "ro-destContact":
                updateInfo["destContact"] = Number(event.target.value);
                break;
            case "requestedBy":
                const contactItem = event.target["contact"];  // augmented
                updateInfo["requestedById"] = contactItem.id;
                updateInfo["requestedByName"] = contactItem.fullName;
                break;
            default:
                updateInfo[thing] = event.target.value;
                break;
        }
        
        // these 2 need to stay in sync
        if (!isInitializing) {
            updateInfo["saved"] = false;
            updateSavedFlagTo(false);
        }

        await LICache.setRetrievalInfo(updateInfo);
        setRetrievalInfo(updateInfo);
    }
    
    function getReturnDateBasedOnLocation(locationId):Date {
        let nowDate = new Date();
        const selectedDestLocation = globalState.locations.find( item => item.id===locationId);
        if(selectedDestLocation) {
            let dueBackDays:Number = selectedDestLocation.dueBackDays;
            console.debug(`selected location id '${locationId}' dueBackDays='${dueBackDays}'`);
            
            if(!dueBackDays || dueBackDays<=0) { // go with default
                dueBackDays = DEFAULT_DUE_DATE;
            }
            nowDate.setDate(nowDate.getDate()+dueBackDays);
        }
        return nowDate;
    }
    
    function checkForValid() {
        const goodNessList = {...infoGoodnessList};
        let isValid=0;
        if(retrievalInfo.requestedById>0 && retrievalInfo.requestedByName!=="") { // mark green
            isValid|=1;
            goodNessList["requestedBy"]="good";
        }
        else {
            goodNessList["requestedBy"]="bad";
        }
        if(LIUtils.existsAndNotEmpty(retrievalInfo.createdByName)) { // mark green
            isValid|=2;
        }
        if(hasDestination()) { // mark green
            isValid|= 4;
            goodNessList["destLocation"]="good";
        }
        else {
            goodNessList["destLocation"]="bad";
        }
        if(dueBackDateIsGood()) { // mark green
            isValid|= 8;
            goodNessList["dueBackDate"]="good";
        }
        else {
            goodNessList["dueBackDate"]="bad";
        }
        
        setInfoGoodnessList(goodNessList);
        setFormIsValid(isValid >= 15); // all good if all flags=1
    }
    
    function hasDestination() {
        return retrievalInfo.destLocation>0;
    }
    
    function dueBackDateIsGood() {
        const date = retrievalInfo.dueBackDate;
        if(!date) return false;
        const ticks = date.getTime();
        /* // get the ticks for midnight tonight
        const today = new Date();
        today.setHours(0,0,0,0);
        return date && ticks>=today.getTime(); */
        return ticks>Date.now();
            
    }
    
    function handleFormSubmit(event) {
        event.stopPropagation(); // let the validation checks run
        event.preventDefault();

        const form = document.getElementById('retrievalOrderForm');
        if (form.checkValidity() === false) {
            return;
        }
        if(retrievalInfo.permanentlyRemove) { // show warning.
            Popup.showConfirm("Permanently Remove Reminder","<p>You have Permanent Removal enabled for all samples.</p>" +
                            "<p>This means any samples picked from this RO will be <strong>permanently removed from the system</strong>.</p>",
                            "Yes, This is OK",null,() => {
                doFormSave();
            });
        }
        else {
            doFormSave();
        }
    }
    
    function doFormSave() {
        setIsSaving(true);
        if(isNewOrder()) { // ADD NEW ORDER
            ArchiverClientApi.sendAddRetrievalOrder(retrievalInfo)
            .then(({order, _}) => {
                
                Popup.showInfoWithButtonTimed(`Retrieval Order ${LIUtils.prettyOrderNumber(order.id)} Saved`, async () => {
                    updateSavedFlagTo(true);
                    //await markFormIsDirty(false); // delayed dirty update! (but still after 
                    await LICache.clearRetrievalInfo(); // ensure our long-term store is clear
                    setRedirectToReplace("/retrievals");  // force getting the order id set-up
                }, true,0,true,5000);
            })
            .catch( errorResponse => ErrorPopup.showError("Save Failed",errorResponse.error))
            .finally(() => {
                setIsSaving(false);
            });
        }
        else { // UPDATE EXISTING ORDER
            ArchiverClientApi.sendUpdateRetrievalOrder(orderId,retrievalInfo)
            .then(({order, _}) => {
                Popup.showInfoWithButtonTimed(`Retrieval Order ${LIUtils.prettyOrderNumber(order.id)} Updated`, async () => {
                    await markFormIsDirty(false);
                    setCheckForCompleted(true);
                },true,0,true,5000);
            })
            .catch( errorResponse => ErrorPopup.showError("Save Failed",errorResponse.error))
            .finally(() => {
                setIsSaving(false);
            });
        }
    }
    
    function handleSampleClicked(sampleId) {
        setRedirectToPush(`/sample_details/${sampleId}`);
    }

    function handleSamplePendingOrderClicked(orderId) {
        if(!savedFlag) {
            Popup.showConfirm("","Changes have not been saved.  Really leave?","Leave",null,() => {
                    window.location.replace(`/retrievals/details/${orderId}`); // # ### full refresh here, which seems extreme -pott 220201
                },
                null, null, "Stay");
        }
        else {
            window.location.replace(`/retrievals/details/${orderId}`);
        }
    }
    
    function sampleHasBeenPicked(sample) {
        return sample.parentOrderId===Number(orderId) && sample.datePickCompleted!=null;
    }
    
    async function handleRemoveSample(sampleId) {
        const sample = retrievalInfo.samples?.find( item => item.id===sampleId);
        if(sampleHasBeenPicked(sample)) { // this sample has already been picked
            Popup.show("Sample Cannot Be Removed","This sample has already been picked and can no longer be removed from the order",null);
            return;
        }
        await LICache.removeSamplesFromRetrievalList([sample]);
        await readRetrievalInfoFromStorage(); // ### inefficient.
    }

    function handleSampleRepairClicked(sampleId) {
        setRedirectToEditorWithSample(sampleId);
    }
    
    function generatePageTitle() {
        if (orderId === -1) {
            return (<h1 className="d-inline-block align-middle">New Retrieval Order</h1>);
        }
        return(
            <div>
                <h1 className="d-inline-block align-middle">Retrieval Order</h1>
                <div className="text-right li-font-medium"><i>Order #:</i> {LIUtils.prettyOrderNumber(retrievalInfo?.orderId)}</div>
            </div>
        );
    }
    
    function isNewOrder():boolean {
        return !orderId || orderId==="" || Number(orderId)===-1;
    }
    
    function showPickAndPrintIfRequired() {
        if (isNewOrder()) { // don't show for completed or new orders
            return null;
        }

        let pickCompletedExtra = null;
        if (orderStatus.isPickedCompleted) {
            pickCompletedExtra = <div className="badge badge-success li-font-medium col-10">
                <span className="fa fa-check align-self-center mt-1"></span>&nbsp;This order has been fully picked
            </div>;
        }

        if(shouldFormBeReadOnly()) { // dump print button only
            return (
                <div className={"row "+(pickCompletedExtra?"justify-content-between":"justify-content-end")}>
                    {pickCompletedExtra}
                    <button id="printSheetBtn" className="li-button li-primary" onClick={handlePrintPage}>Print</button>
                </div>
            );
        }

        return(
            <div className="text-right mt-3">
                <button id="genPickSheetBtn" className="li-button li-primary mr-5"
                        disabled={!savedFlag || hasNoSamplesOnOrder()}
                        onClick={handleGeneratePickSheet}>Generate Pick sheet</button>
                <button id="printSheetBtn" className="li-button li-primary" onClick={handlePrintPage}>Print</button>
            </div>
        );
    }
    
    function hasNoSamplesOnOrder() {
        return !retrievalInfo?.samples?.length;
    }

    function handleGeneratePickSheet() {
        
        if(LIUtils.UserHasLevel(cookies,"PICKER")) {
            // update our location.state so if user goes BACK from the picksheet, we reload the RO
            if(!savedFlag) {
                Popup.showConfirm("","Changes have not been saved.  Really leave?","Leave",null,() => {
                    setRedirectToPicksheet(orderId);
                },
                    null, null, "Stay");
                return;
            }
            setRedirectToPicksheet(orderId);  
        }
        else {
            Popup.show("", "<p>You are not a SAMPLE PICKER type user.</p>" +
                "Talk to your Archiver Administrator if you wish to change this.");
        }
    }
    function handlePrintPage() {
        window.print();
    }
    
    async function handleBackClicked() {
        if(!savedFlag) {
            Popup.showConfirm("","Changes have not been saved.  Really leave?","Leave",null,async () => {
                    await clearCacheAndGoBackToRetrievals();
                },
                null, null, "Stay");
        }
        else {
            await clearCacheAndGoBackToRetrievals();
        }
    }

    async function clearCacheAndGoBackToRetrievals() {
        await LICache.clearRetrievalInfo(); // wipe out any edits
        setRedirectToReplace("/retrievals");
    }
    
    function checkForOnlyPickedSamplesAndShowPopup(samples) {
        // get the samples that are either not picked yet, or brand new added
        const unpicked = samples.filter(s => (s.datePickCompleted===null || s.datePickCompleted===undefined));
        if(unpicked.length===0 && samples.length>0) { // only picked remain
            Popup.showConfirm("Complete the Order?","All samples on this order have been picked.<p>Do you want to move it to Unsent/Completed?",
            "Yes, Move it",null,() => {
                    ArchiverClientApi.markRetrievalAsPicked(orderId)
                    .then(async () => {
                        await LICache.clearRetrievalInfo(); // ensure our long-term store is clear
                        setRedirectToReplace("/retrievals");
                    })
                    .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
                    .finally(() => {
                        setIsSaving(false);
                    });
                }, null,null,"No");
        }
    }

    async function handleAddNoteClicked() {
        Popup.showPrompt("Add Note","","Save",() => {},
            async (noteText) => {
            await doAddNoteToOrderAtServer(retrievalInfo.orderId, noteText);
        },1);
    }

    async function doAddNoteToOrderAtServer(orderId, noteText) {
        try {
            const updatedNote:string = await ArchiverClientApi.addNoteToROAtServer(orderId, noteText);
            await LICache.updateRetrievalNote(updatedNote);
            await readRetrievalInfoFromStorage(); // ### inefficient
        } catch (responseError) {
            ErrorPopup.showError("Error", responseError);
        }
    }
    
    if(redirectToCaseInventory) {
        const stateObj = {roInProgress: true, roOrderId: orderId};
        return( <Redirect to={{
                pathname: `/case_inventory/${selectedCase.id}/${selectedCase.number}`,
                state: stateObj
            }}/>
        );
    }
    if(redirectToPush) {
        return <Redirect push to={redirectToPush}/>;
    }
    if(redirectToReplace) {
        return <Redirect to={redirectToReplace}/>;
    }
    if(redirectToEditorWithSample) {
        return <Redirect push to={{
            pathname: `/attention_edit/${redirectToEditorWithSample}`,
            state: {roInProgress: true, from:"ro"}
        }}/>;
    }
    if(redirectToPicksheet) {
        // picksheet clears roInProgress so we get a fresh sample list after picking from the server - pott 260714
        history.replace(location.pathname, null) // null out state
        return <Redirect push to={`/pick_sheet?${redirectToPicksheet}`}/>;
    }

    async function forceCacheClearReload() {
        await LICache.clearAll(); // wipe out any edits
        history.go(0);
    }

    return(
        <div className="container">
            <Header/>
            <div className="row li-header-row m-0 p-0 justify-content-between">
                    <div className="align-self-center">
                        <BackButton onClick={handleBackClicked}/>
                        <div className="d-inline-block align-middle">{generatePageTitle()}</div>
                        <div className="d-inline-block ml-5">{isLoading && <LoadingSpinner medium/>}</div>
                    </div>
                {showClearButtonIfRequired()}
                <button className="btn ml-auto mr-3 align-self-center" onClick={forceCacheClearReload}
                        data-toggle="tooltip" data-placement="bottom" title="Reload">
                    <i className="fa fa-redo"/></button>

            </div>

            <div style={{minHeight:"800px"}}>
                {isInitializing && <div className="text-center">...Loading Retrieval Order...</div>}
                {!isInitializing && <>
                {showPickAndPrintIfRequired()}
    
                <RetrievalOrderForm onSubmit={handleFormSubmit} retrievalInfo={retrievalInfo}
                                    onAddSamples={handleAddSamples} 
                                    onAddSamplesViaBarcode={handleAddSamplesViaBarcode}
                                    onDateChanged={handleDueDateChanged}
                                    onChange={handleInfoChanged} goodNess={infoGoodnessList}
                                    onSampleClicked={handleSampleClicked}
                                    onSampleOrderClicked={handleSamplePendingOrderClicked}
                                    onSampleRepairClicked={handleSampleRepairClicked}
                                    onRemoveSample={handleRemoveSample}
                                    formIsValid={formIsValid}
                                    formIsReadOnly={shouldFormBeReadOnly()} 
                                    isSaving={isSaving} isDirty={!savedFlag}
                                    onAddNoteClicked={handleAddNoteClicked}
                                    newlyAddedSampleIds={newlyAddedSampleIds}/>
                </>
            }
            </div>
            <Toaster position="top-center" reverseOrder={false} gutter={8}/>
        </div>  
    );
    
}

export default AddUpdateROPage;